"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendMessageToHost = exports.process = exports.test = exports.read = exports.write = exports.voyageMessageId = void 0;
var messageWriter_sidecar_1 = require("@engine/messageWriter-sidecar");
var websockets_sidecar_1 = require("@engine/websockets-sidecar");
var assert_sidecar_1 = require("@lib/assert-sidecar");
var voyageMessageIds_1 = require("./voyageMessageIds");
var diveSimulationManager_sidecar_1 = require("@dive/simulation/diveSimulationManager-sidecar");
var voyageWebsockets_1 = require("@voyage/multi-sockets/voyageWebsockets");
exports.voyageMessageId = voyageMessageIds_1.EVoyageMessage.Dive_GameSync;
function write(m, d) {
    messageWriter_sidecar_1.messageWriter.write8(m, exports.voyageMessageId);
    messageWriter_sidecar_1.messageWriter.write16(m, d.gameSyncNumber);
}
exports.write = write;
function read(m) {
    var t = messageWriter_sidecar_1.messageWriter.read8(m);
    assert_sidecar_1.assert.eq(t, exports.voyageMessageId);
    var d = {
        gameSyncNumber: messageWriter_sidecar_1.messageWriter.read16(m),
    };
    return d;
}
exports.read = read;
function test() {
    var ex = {
        gameSyncNumber: 1589,
    };
    messageWriter_sidecar_1.messageWriter.test('gameSync', ex, write, read);
}
exports.test = test;
function process(m, isFromHost, fromId) {
    var msg = read(m);
    if (voyageWebsockets_1.getIsHost()) {
        diveSimulationManager_sidecar_1.diveSimulationManager.updateGameSyncNumberForPlayer(fromId, msg.gameSyncNumber);
    }
}
exports.process = process;
function sendMessageToHost(msg) {
    websockets_sidecar_1.websockets._sendMessageToHost(write, msg, true);
}
exports.sendMessageToHost = sendMessageToHost;
